import { loader } from 'graphql.macro'

export default function dispatchResources ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const schema = loader('./dispatchSites.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, {
    haulerId: variables.haulerId
  })
}
